import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import userbase from 'userbase-js'
import { PrivateRoute } from './components/PrivateRoute'
import { ActivityFeed } from './pages/ActivityFeed'
import { EditProfile } from './pages/EditProfile'
import { Home } from './pages/Home'
import { Loading } from './pages/Loading'
import { Login } from './pages/Login'
import { NewPerson } from './pages/NewPerson'
import { Register } from './pages/Register'
import { Welcome } from './pages/Welcome'

import { Header } from './components/Header'

const App = () => {
  const [user, setUser] = useState()
  const [ready, setReady] = useState()

  useEffect(() => {
    userbase
      .init({ appId: process.env.REACT_APP_USERBASE_APP_ID, updateUserHandler })
      .then((session) => {
        session.user && setUser(session.user)
        setReady(true)
      })
  }, [])

  const updateUserHandler = ({ user }) => {
    setUser(user)
  }

  return (
    <Router basename="/bubbel">
      <Header user={user} setUser={setUser} ready={ready} />
      <div>
        {!ready && <Loading />}
        {user ? (
          <Switch>
            <PrivateRoute user={user} path="/edit">
              <EditProfile user={user} setUser={setUser} />
            </PrivateRoute>
            <PrivateRoute user={user} path="/feed">
              <ActivityFeed />
            </PrivateRoute>
            <PrivateRoute user={user} path="/new">
              <NewPerson user={user} setUser={setUser} />
            </PrivateRoute>
            <PrivateRoute user={user} path="/">
              <Home user={user} />
            </PrivateRoute>
          </Switch>
        ) : (
          <Switch>
            <Route path="/register">
              <Register ready={ready} setUser={setUser} />
            </Route>
            <Route path="/login">
              <Login ready={ready} setUser={setUser} />
            </Route>
            <Route path="/">
              <Welcome ready={ready} />
            </Route>
          </Switch>
        )}
      </div>
    </Router>
  )
}

export default App
